// API base URL. Override per environment via REACT_APP_API_BASE_URL (CRA env).
// - Local dev against staging:  set it in .env.development.local to the
//   PostalLookup-staging stack's ApiUrl (a *.execute-api.*.amazonaws.com URL).
// - Production build: .env.production pins the public domain.
// The API sends `Access-Control-Allow-Origin: *`, so a localhost dev server can
// call any of these directly with no CORS proxy.
const RAW =
  process.env.REACT_APP_API_BASE_URL ||
  'https://api.translate-japanese-address.com';

export const API_BASE_URL = RAW.replace(/\/+$/, '');
